<template>
    <div class="scrollbar registrationSteps p-3">
        <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
        <div class="CustomBlockWidth changePass inMiddle-area whitebox p-4">  
            <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
            <div class="justify-content-center"> 
                
                <div class="form-group field-wrapper dob">
                    <div class="position-relative">
                    <input placeholder="" :type="inputtype" v-model="old_password" class="float-field form-control" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('Old Password') }" ref="old_passwordInput" name="Old Password"  />
                    <label for="password" class="float-label">Old Password</label>
                    </div>
                    <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('')"></feather>
                </div>
             
                <div class="form-group field-wrapper dob">
                    <div class="position-relative">
                        <input placeholder=" " :type="inputtype1" v-model="new_password" class="float-field form-control"  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,24}$/}" :class="{ 'is-invalid': submitted && errors.has('New Password') }" ref="new_passwordInput" name="New Password" />
                        <label for="password" class="float-label">New Password</label>
                        <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('1')"></feather>
                    </div>
                </div>
            
                <div class="form-group field-wrapper dob">
                    <div class="position-relative">
                        <input placeholder=" " :type="inputtype2" v-model="confirm_password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/, confirmed:new_password}"  :class="{ 'is-invalid': submitted && errors.has('Confirm Password') }" ref="confirm_passwordInput" name="Confirm Password"  />
                        <label for="password" class="float-label"> Confirm Password</label>
                        <feather :type="iconType2" class="toggle-password" @click.prevent="switchVisibility('2')"></feather>
                    </div>
                </div>
             
                <div class="submitButton d-flex justify-content-center align-items-center w-100 mt-2 text-center">
                    <button class="prism_btn" v-on:click.stop.prevent="changePassword()">Change Password</button>
                </div> 
            </div> 
        </div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { mapActions } from 'vuex'
    import * as types from '@/types'
    export default {
        name: 'Deposit',
        mixins: [fxViewMixins],
        data() {
            return {
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                old_password : '',
                new_password : '',
                confirm_password : '',
                submitted : false,

                inputtype : 'password',
                inputtype1 : 'password',
                inputtype2 : 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                iconType2 : 'eye-off',
                showpassword1 : false,
                showpassword2 : false,
                showpassword : false,
            }
        },
        methods:{
           ...mapActions({
                _runChangePassword: types.RUN_CHANGE_PASSWORD
            }),
           switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }else if(getData == '2'){
                    this.showpassword2 = !this.showpassword2
                    if(this.showpassword2){
                        this.inputtype2 = 'text'
                        this.iconType2 = 'eye'
                    }else{
                        this.inputtype2 = 'password'
                        this.iconType2 = 'eye-off'
                    } 
                }else{
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }
                
            },
            changePassword(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'oldpassword' : _that.old_password ,
                                'password' : _that.new_password
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runChangePassword(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
           clear(){
                this.old_password = ''
                this.new_password = ''
                this.confirm_password = ''
                this.submitted = false
                this.inputtype = 'password'
                this.inputtype1 = 'password'
                this.inputtype2 = 'password'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/change_password.vue